import { ReactNode } from 'react';
import { WebSection } from '@wbk/contentful/api';
import GuideCard from '@/components/guides/GuideCard';
import { Carousel } from '@/components/ui/Carousel';
import ScrollTitle from '@/components/ui/ScrollTitle';

type Props = {
  section?: WebSection;
};

const FeaturedGuides = ({ section }: Props) => {
  const items = section?.contentCollection?.items || [];

  return (
    <div className='container-padding container'>
      <div className='container px-3 xl:px-0'>
        <div className='space-y-6'>
          <ScrollTitle title={section?.title || ''} />

          <Carousel
            className='mt-XXXS [&>ul]:gap-2'
            options={{
              dragFree: true,
              slidesToScroll: 1,
              startIndex: Math.floor(items.length / 2),
              align: 'start',
            }}
            as='ul'
          >
            {
              items.map((item, index) => {
                if (item?.__typename !== 'WebCard') return <div key={index} />;

                return (
                  <GuideCard
                    key={item.id}
                    buttonText={item.buttonLabel}
                    title={item?.title}
                    description={item?.subtitle ?? ''}
                    image={item?.image}
                    href={item?.href}
                    contentClassName='flex-row sm:flex-col sm:items-start items-end justify-between'
                    className='mx-0 shrink-0 basis-[85%] object-cover sm:basis-[60%] md:basis-[50%] lg:basis-[40%] xl:basis-[32%]'
                    // onButtonClick={handleGetTickets}
                  />
                );
              }) as ReactNode[]
            }
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default FeaturedGuides;
